import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { usePrefsStore } from '../stores/prefs';
import am from './locales/am/common.json';
import en from './locales/en/common.json';

void i18next.use(initReactI18next).init({
  resources: { en: { common: en }, am: { common: am } },
  lng: usePrefsStore.getState().language,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18next;
